import { render, staticRenderFns } from "./TabelaHierarquia.vue?vue&type=template&id=4b1e18b8"
import script from "./TabelaHierarquia.vue?vue&type=script&lang=js"
export * from "./TabelaHierarquia.vue?vue&type=script&lang=js"
import style0 from "./TabelaHierarquia.vue?vue&type=style&index=0&id=4b1e18b8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports